/** Business-friendly label for canonical logistics status codes. */
export function formatCanonicalStatus(code) {
  if (!code) return '—';
  const labels = {
    logistics_not_requested: 'Not requested',
    logistics_requested: 'Requested',
    quote_pending: 'Awaiting quotes',
    quotes_received: 'Quotes received',
    quote_comparison_ready: 'Ready to compare',
    quote_accepted: 'Quote accepted',
    shipment_document_pending: 'Documents pending',
    eway_bill_created: 'E-way bill created',
    shipping_manifest_created: 'Manifest created',
    shipment_dispatched: 'Dispatched',
    in_transit: 'In transit',
    out_for_delivery: 'Out for delivery',
    delivered: 'Delivered',
    grn_pending: 'GRN pending',
    grn_completed: 'GRN completed',
    logistics_closed: 'Closed',
    logistics_cancelled: 'Cancelled',
  };
  return labels[code] || String(code).replace(/_/g, ' ');
}
